import React from 'react';

import cx from 'classnames';

import Image from '../../Pages/shared/Image';
import SubTitle from '../../Pages/shared/SubTitle';
import Title from '../../Pages/shared/Title';
import TemplatePage from '../../Pages/TemplatePage';
import s from './index.module.css';

function OrdinaryPage({ children, title, subtitle, withBorder, withTopPadding, image }) {
  return (
    <TemplatePage>
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Title text={title} withBorder={!!subtitle || withBorder} />
        {image && image.url && <Image url={image.url} focalPointCoords={image.focalPointCoords} />}
        {subtitle && <SubTitle text={subtitle} />}
        <div style={{ flex: 1 }} className={cx(withTopPadding && s.topPadding)}>
          {children}
        </div>
      </div>
    </TemplatePage>
  );
}

export default OrdinaryPage;
